import { useTranslation } from 'react-i18next';
import { Alert } from '@statsbomb/kitbag-components';
import { Playlist, PlaylistEntry, VideoEvent } from '@statsbomb/video-client-js';
import { VideoAuthAndKeyboardWrapper } from '../VideoProvider';

export const VideoPlayer = ({
  videoEvents = [],
  unavailableVideosCount,
}: {
  videoEvents?: PlaylistEntry[];
  unavailableVideosCount?: number;
}) => {
  const { t } = useTranslation('video');

  return (
    <VideoAuthAndKeyboardWrapper>
      <VideoEvent autoPlay events={videoEvents} />
      {!!unavailableVideosCount && (
        <div className="pt-4">
          <Alert isFullWidth type="info">
            {t('noLicenceCount', { count: unavailableVideosCount })}
          </Alert>
        </div>
      )}
      <div className="max-h-[300px] md:max-h-[700px] overflow-auto">
        {videoEvents.length > 0 && <Playlist enableEditMode enableSelectAll />}
      </div>
    </VideoAuthAndKeyboardWrapper>
  );
};
